import React, {
    useReducer,
    useMemo,
    useState,
    useEffect,
    useContext,
    Fragment,
    useRef,
  } from "react";
  import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    getExpandedRowModel,
    createRow,
    expandRows,
    RowSelection,
  } from "@tanstack/react-table";
  import { t } from "i18next";
import studylistContext from "../../../../context/studylist/StudylistContext";
import {
  CXR_TABS_NAME,
  HIDE_LOCK_ICON_TABS,
  QC_TABS,
  QC_TABS_NAME,
  REPORTDONESTATUS,
  REPORTED_TABS_NAME,
  STORAGE_TYPE,
  TAB_NAME,
  TOAST_TYPE,
  USERTYPES,
  widthOfColumns,
} from "../../../../constants/Constants";
import {
  Checkbox,
  DefaultButton,
  Icon,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import Accordian from "../../../../components/SVGComponents/Accordian";
import LockOpen from "../../../../components/SVGComponents/LockOpen";
import Lock from "../../../../components/SVGComponents/Lock";
import {
  assignMe,
  assignMeSupervisor,
  assignMeTypist,
  batchAssignProvider,
  batchDeleteStudyApi,
  batchReinferenceStudyApi,
  getOrderStudies,
  getPriors,
  getStudyStatus,
} from "../../../../service/StudyListService";
import toastContext from "../../../../context/toast/ToastContext";
import userContext from "../../../../context/users/UserContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { ReleaseStudyApi } from "../../../../service/StudyViewerService";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalMain from "../../../../components/Modal/ModalMain";
import themeContext from "../../../../context/theme/ThemeContext";
import loaderContext from "../../../../context/loader/LoaderContext";
import { RowBadgeStatic } from "../RadiologistDetails";
import { getEnv } from '../../../../helpers/EnvHelper';

const IndeterminateCheckbox = ({ indeterminate, className = "", ...rest }) => {
    const {
        filterInputValues,
        showCount,
        setShowCount,
        refreshRequired,
        setRefreshRequired,
        storedRows,
        setStoredRows,
        studyListLoading,
        setStudyListLoading,
        studyListRef,
        dataQueryState,
        setDataQueryState,
        updateLockUnlockRows,
        setUpdateLockUnlockRows,
        setSearchResultLength,
        menuItemsForBatchAndInference,
        rowSelectionState, setRowSelectionState,
        setRowSelectedArray,
        rowSelectedArray,
        getCountOfAbleToDeleteStudies,
        handleBatchReInference,
        batchReinferenceAndDeleteArray,
        resetRowSelection,
        setResetRowSelection,
        handleBatchDelete,
        unreportedAllTabs,
        fetchData,
        allowDeleteStudy,
        roles,
        imageStatusStudyIdsRef, 
        fetchImageUploadStatus
      } = useContext(studylistContext);

    

    const {setAlertSuccessModal, alertSuccessModal} = useContext(studyReportContext);
    const [priorsLoading,setPriorsLoading] = useState(false);     
    const { userId,username ,contextSwitchUser , isActiveData, qcSelfLockDisabled} = useContext(userContext)
    const isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;
    const isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_VDC_PLATFORM") == true) ? true : false;

    const [showOrderModal, setShowOrderModal] = useState(false);
    const [orderDetails, setOrderDetails] = useState([]);
    const { getThemeColor} = useContext(themeContext);
    const { setLoaderRunning } = useContext(loaderContext);
    const { showToastv2, updateToastv2, list, setList } = useContext(toastContext);

    const [loadingLockUnlock, setLoadingLockUnlock] = React.useState(false);

    const props = rest.data;
    const loggedInUserRole = rest.roles[0];
    const rowSelection = rest.rowSelection;
    const hideMultiSelectAndUnlock =
      !!rest.hideMultiSelectAndUnlock || props?.id === TAB_NAME.ALL;

    const mainStackStyle = {
      justifyContent: "space-evenly",
      alignItems: "center",
    };
  
    const checkBoxStyle = {
      root: {
        paddingLeft: "5px",
      },
      checkbox: {
        position:'unset',
        boxSizing: 'unset',
        borderColor: "#8A8886",
        width: "16px",
        height: "16px",
        pointerEvents: 'none',
      },
    };
  
    const hideCheckBox = {
      root: {
        display: 'none'
      }
    }
  
    const disabledcheckBoxStyle = {
      root: {
        paddingLeft: "5px",
        display:'none'
      },
      checkbox: {
        borderColor: "#8A8886",
        width: "16px",
        height: "16px",
        pointerEvents: 'none',
      },
    };
  
    const smallSpinnerStyle = {
      circle: {
        height: "15px",
        width: "15px",
        borderWidth: "3px",
      },
      label: {
        color: "white",
      },
    };

    const fetchPriorsData = async (row) => {
      const priorListSearchDto = {
        studyId: row.original.id,
      };
  
      if (row.subRows.length === 0) {
        try{
          setPriorsLoading(true);
          const response = await getPriors(priorListSearchDto);
          console.log("Priors List response");
    
          if (response.status === 200 && response.data.result === "SUCCESS") {
            setPriorsLoading(false);
            const priorsData = response.data.data.studies.searchResults;
            const priorStudyIds = priorsData.map(prior => prior.id).filter(Boolean);

            priorStudyIds.forEach(id => {
              imageStatusStudyIdsRef.current.add(id);
            });

            if (priorStudyIds.length > 0) {
              await fetchImageUploadStatus();
            }

            const priorsRow = priorsData.map((data, index) => {
              if(index === 0) {
                return createRow(
                  rest.table,
                  row.id + "." + index,
                  priorsData,
                  index,
                  1,
                  [],
                  row.id
                );
              }
              return createRow(
                rest.table,
                row.id + "." + index,
                data,
                index,
                1,
                [],
                row.id
              );
            });
    
            priorsRow[0].original = priorsRow[0].original[0];
            
            const priorsRowData = expandRows({ rows: priorsRow });
            
            row.subRows = priorsRowData.rows;
          }else{
            setPriorsLoading(false);
            setAlertSuccessModal(()=>{
              const newItem = {...alertSuccessModal};
              newItem.show = true;
              newItem.heading = "Error";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = response.data.message;
              return newItem;
            });
          }
        }catch(e){
          setPriorsLoading(false);
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Error";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.error-msg");
            return newItem;
          });
        }
      }
      console.log(row);
      if (row.getCanExpand()) {
        row.toggleExpanded();
      }
    };
  

    const renderUnLockIcon = (rest) => {
      if (
        (loggedInUserRole === USERTYPES.RADIOLOGIST) &&
        props.id != "qcfix" 
        && props.showAllStudies
      ) {
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.assignmentList[0] != undefined &&
          !(rest.row.original.assignmentList[0].providerId != null) &&
          rest.row.original.allowAssignment
        ) {
          return true;
        }
      }
      if (
        (loggedInUserRole === USERTYPES.TYPIST) 
      ){
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.typistId === 0
        ) {
          return true;
        }
      }
      return false;
    };
  
    const renderUnLockForSupervisorIcon = (rest) => {
      if (
        (((props.id == TAB_NAME.QCREVIEW || props.id == TAB_NAME.QCREVIEWASSIGNED) && !qcSelfLockDisabled) || props.id == TAB_NAME.QCVERIFY) &&
        roles[0] == USERTYPES.SUPERVISOR
      ) {
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.assignmentList[0] != undefined &&
          (((rest.row.original.assignmentList[0].qcreviewerId == null || rest.row.original.assignmentList[0].qcreviewerId == undefined)
                && (props.id == TAB_NAME.QCREVIEW || props.id == TAB_NAME.QCREVIEWASSIGNED)) || 
            (((rest.row.original.assignmentList[0].qcverifierId == null 
              || rest.row.original.assignmentList[0].qcverifierId == undefined) && props.id == TAB_NAME.QCVERIFY)
            ))
        ) {
          return true;
        }
      }
      return false;
    };

    const renderLockIcon = (rest) => {

      if(rest.row?.depth > 0) return false;

      if(props.id == TAB_NAME.PENDING || props.id == TAB_NAME.APPROVED || props.id == TAB_NAME.REJECTED){
        return false;
      }
      if (
        props.roles[0] === USERTYPES.RADIOLOGIST &&
        rest.row != undefined &&
        rest.row.original != undefined &&
        rest.row.original.assignmentList[0].providerId != undefined &&
        rest.row.original.assignmentList[0].providerId != 0 &&
        rest.row.original.reportDoneStatus < 2 &&
        isBvpPlatform && 
        rest.row.original.assignmentList[0].providerId==="R" + userId
      ) {
        return true;
      }

      if (
        (props.roles[0] === USERTYPES.ADMIN ||
          props.roles[0] === USERTYPES.FIRMADMIN ||
          props.roles[0] === USERTYPES.SUPERVISOR) &&
        props.id != TAB_NAME.QCFIX
      ) {
        // console.log("--- CHecking Render Lock Icon ----");
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.assignmentList[0].providerId != undefined &&
          rest.row.original.assignmentList[0].providerId != 0 &&
          !(rest.row.original.assignmentList[0].closed == 0 ? false : true) 
          && rest.row.original.reportDoneStatus < 2
        ) {
          return true;
        }
      }
      return false;
    };
  
    const renderLockIconForQCTab = (rest) => {

      if(rest.row?.depth > 0) return false;

      if (
        (props.roles[0] === USERTYPES.ADMIN ||
          props.roles[0] === USERTYPES.FIRMADMIN 
          //|| props.roles[0] === USERTYPES.SUPERVISOR
          ) 
          && props.id != "qcfix"
      ) {
        // console.log("--- CHecking Render Lock Icon ----");
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.assignmentList[0].qcreviewerId != null &&
          !(rest.row.original.assignmentList[0].closed == 0 ? false : true) 
          && (rest.row.original.reportDoneStatus == 3 || rest.row.original.reportDoneStatus == 7)
        ) {
          return true;
        }
  
        if (
          rest.row != undefined &&
          rest.row.original != undefined &&
          rest.row.original.assignmentList[0].qcverifierId != null &&
          !(rest.row.original.assignmentList[0].closed == 0 ? false : true) 
          && (rest.row.original.reportDoneStatus == 5 || rest.row.original.reportDoneStatus == 9)
        ) {
          return true;
        }
  
      }
      return false;
    };

    const handleRowUpdateForLock = (data, responseObject, lock) => {
      setUpdateLockUnlockRows((prev) => !prev);
      let newIndex = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id == data.id) {
          newIndex = index;
          return true;
        }
        return false;
      });
      if (lock) {
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          newValue.data.rows[newIndex].assignmentList[0]["providerName"] =
            responseObject?.reportingProviderName;
            
          newValue.data.rows[newIndex].assignmentList[0]["providerId"] =
            "R" + userId;
          if(newValue.data.rows[newIndex].assignmentList[0]?.studyAccessCode == null || newValue.data.rows[newIndex].assignmentList[0]?.studyAccessCode === undefined  )
            newValue.data.rows[newIndex].assignmentList[0]["studyAccessCode"] =
              responseObject?.studyAccessCode;
            
          return newValue;
        });
      } else {
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          newValue.data.rows[newIndex].assignmentList[0].providerName = "";
          newValue.data.rows[newIndex].assignmentList[0].providerId = undefined;
          const newAssignmentList =
            newValue.data.rows[newIndex].assignmentList[0];
          newValue.data.rows[newIndex].assignmentList = [newAssignmentList];

          return newValue;
        });
      }
    };

    const handleRowUpdateForTypistLock = (data, typistId) => {
      setUpdateLockUnlockRows((prev) => !prev);
      let newIndex = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id == data.id) {
          newIndex = index;
          return true;
        }
        return false;
      });
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          newValue.data.rows[newIndex].typistId =typistId;
            
          return newValue;
        });
    };


    const handleRowUpdateForLockSupervisor = (data, responseObject, lock) => {
      setUpdateLockUnlockRows((prev) => !prev);
      let newIndex = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id == data.id) {
          newIndex = index;
          return true;
        }
        return false;
      });
      if (lock) {
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          if(props.id === TAB_NAME.QCREVIEW || props.id === TAB_NAME.QCREVIEWASSIGNED){
            newValue.data.rows[newIndex].assignmentList[0]["qcreviewerName"] =
            responseObject;
          newValue.data.rows[newIndex].assignmentList[0]["qcreviewerId"] =
            "S" + userId;
          }else{
            newValue.data.rows[newIndex].assignmentList[0]["qcverifierName"] =
            responseObject;
          newValue.data.rows[newIndex].assignmentList[0]["qcverifierId"] =
            "S" + userId;
          }
          
          return newValue;
        });
      } else {
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          if(props.id === TAB_NAME.QCREVIEW || props.id === TAB_NAME.QCREVIEWASSIGNED){
            newValue.data.rows[newIndex].assignmentList[0].qcreviewerName = "";
            newValue.data.rows[newIndex].assignmentList[0].qcreviewerId = null;
          }else{
            newValue.data.rows[newIndex].assignmentList[0].qcverifierName = "";
            newValue.data.rows[newIndex].assignmentList[0].qcverifierId = null;
          }
          
          const newAssignmentList =
            newValue.data.rows[newIndex].assignmentList[0];
          newValue.data.rows[newIndex].assignmentList = [newAssignmentList];

          return newValue;
        });
      }
    };

    const ref = React.useRef(null);
    const displayLockIcon = renderLockIcon(rest);
    const displayLockIconForQCTab = renderLockIconForQCTab(rest);
    const displayUnlockIcon = renderUnLockIcon(rest);
    const displayUnlockIconForSupervisor = renderUnLockForSupervisorIcon(rest);
    
    // console.log("--- Updated Icons ----",displayLockIcon,displayLockIconForQCTab,displayUnlockIcon,displayUnlockIconForSupervisor);
    const menuProps = {
      shouldFocusOnMount: true,
      items: menuItemsForBatchAndInference(rowSelection),
    };

    React.useEffect(() => {
      if (
        typeof indeterminate === "boolean" &&
        (props.roles[0] == USERTYPES.ADMIN ||
          props.roles[0] == USERTYPES.FIRMADMIN ||
          (props.roles[0] == USERTYPES.SUPERVISOR && allowDeleteStudy))
      ) {
        if(ref.current != null){
          ref.current.indeterminate = !rest.checked && indeterminate;
        }
        
      }
    }, [ref, indeterminate, allowDeleteStudy]);

    const unassignProvider = async (data) => {
      console.log("unassigning study");
      const body = {
        reportingProvider: {
          studyId: rest.row.original.id,
          clientId: rest.row.original.assignmentList[0].clientId,
          firmId: rest.row.original.assignmentList[0].firmId,
          assignedProviderId: rest.row.original.assignmentList[0].providerId,
        },
        isAssign: false,
      };
      console.log(body);
      setLoadingLockUnlock(true);
      const response = await assignMe(body);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        //ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, t("study-list.messages.unassign-success"));
        handleRowUpdateForLock(data, "", false);
        setLoadingLockUnlock(false);
      } else {
        //ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message != null ? response.data.message : t("study-list.messages.assign-error"));
        setLoadingLockUnlock(false);
      }
    };

    const assignProvider = async (data) => {
      console.log("Radiologist assigning study to itself");
      const body = {
        reportingProvider: {
          studyId: rest.row.original.id,
          clientId: rest.row.original.assignmentList[0].clientId,
          firmId: rest.row.original.assignmentList[0].firmId,
          //assignedProviderId: rest.row.original.assignmentList[0].providerId,
        },
        isAssign: true,
      };
      setLoadingLockUnlock(true);
      const response = await assignMe(body);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, t("study-list.messages.assign-success"));
        handleRowUpdateForLock(data, response.data.data, true);
        setLoadingLockUnlock(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message != null ? response.data.message : t("study-list.messages.assign-error"));
        setLoadingLockUnlock(false);
      }
    };

     const releaseStudy = async (data) => {
        console.log("releasing study", rest.row.original.id);
        const response = await ReleaseStudyApi(rest.row.original.id);

         setLoadingLockUnlock(true);
      if (response.data.result == "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, "Study Released Successfully");
        handleRowUpdateForLock(data, "", false);
        setLoadingLockUnlock(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Error while releasing study");
        setLoadingLockUnlock(false);
      }
      };

    const assignReviewer = async (data,isAssign,isReviewer) => {
      console.log("--- Supervisor assigning --- ");
      const body = {
        reportingProviderDto: {
          studyId: rest.row.original.id,
          clientId: rest.row.original.assignmentList[0].clientId,
          firmId: rest.row.original.assignmentList[0].firmId,
          assignedProviderId: rest.row.original.assignmentList[0].qcreviewerId,
        },
        isAssign: isAssign,
        isReviewer: isReviewer
      };
      setLoadingLockUnlock(true);
      const response = await assignMeSupervisor(body);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, (displayLockIcon || (displayLockIconForQCTab && QC_TABS.includes(props.id)))?
        t("study-list.messages.unassign-success"):
         t("study-list.messages.assign-success"));
        handleRowUpdateForLockSupervisor(data, response.data.data, isAssign);
        setLoadingLockUnlock(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Error in unassigning study");
        setLoadingLockUnlock(false);
      }
    };

    const assignTypist = async (data) => {
      console.log("---Typist assigning --- ");
      const body = {
        studyId: rest.row.original.id,
        // isAssign: isAssign,
        // isReviewer: isReviewer
      };
      setLoadingLockUnlock(true);
      const response = await assignMeTypist(body);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, 
         t("study-list.messages.assign-success"));
        handleRowUpdateForTypistLock(data, userId);
        setLoadingLockUnlock(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
        setLoadingLockUnlock(false);
      }
    };

    const checkForAllowBatchOptions = (roles,data) => {
      console.log("--- Data ---",data);
        if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN){
          if(data.assignmentList[0].clientId == 0
            && data.reportDoneStatus > 0 || data.assignmentList[0]?.providerId != null ){
              return true;
            }else{
              return false;
            }
        }
      return false;
    }

    const getSupervisorlockMessage = () => {
      if(props.id == TAB_NAME.QCREVIEW || props.id == TAB_NAME.QCREVIEWASSIGNED){
        return t("study-list.messages.lock-start-reviewing");
      }else if(props.id == TAB_NAME.QCVERIFY){
        return t("study-list.messages.lock-start-verification");
      }
      return t("study-list.messages.lock-start-reviewing");
    }

    const getFirmAdminUnLockMessage = () => {
      if(props.id == TAB_NAME.QCREVIEW || props.id == TAB_NAME.QCREVIEWASSIGNED){
        return t("study-list.messages.unlock-start-reviewing");
      }else if(props.id == TAB_NAME.QCVERIFY){
        return t("study-list.messages.unlock-start-verification");
      }
      return t("study-list.messages.unlock-start-verification");
    }

    const handleOpenOrderModal = async (rowData) => {
      try {
        setLoaderRunning(true);
        setShowOrderModal(true);

        const response = await getOrderStudies(rowData.id, rowData.orderId);
        setOrderDetails(response.data.data);

      } catch (error) {
        console.error("Error fetching order details", error);
      } finally {
        setLoaderRunning(false);
      }
    };

    const tableStyle = {
      width: "100%",
      color: getThemeColor("primary-color"),
      fontWeight: "400",
      fontFamily: "Open Sans",
    };

    const headStyle = {
      padding: "10px",
      textAlign: "center",
      border: "1px solid #878282",
    };

    const thheadStyle = {
      padding: "10px",
      textAlign: "center",
      border: "1px solid #878282",
      borderBottom:'none'
    };

    const modalDetails = {
      header: (
        <ModalHeader
          updatedModal={true}
          heading="Other Studies in this Order"
          handleCancel={() => setShowOrderModal(false)}
        />
      ),
      body: (
        <div
          className="global-modal-body"
          style={{ color: getThemeColor("primary-color") }}
        >
          {orderDetails.length === 0 ? (
            <div>No other studies found.</div>
          ) : (
            <table style={tableStyle}>
              <thead>
                <tr>
                  <React.Fragment>
                    <th style={thheadStyle}>Accession Number</th>
                    <th style={thheadStyle}>Modality</th>
                    <th style={thheadStyle}>Service Name</th>
                    <th style={thheadStyle}>Image Count</th>
                    <th style={thheadStyle}>Reporting Status</th>
                  </React.Fragment>
                </tr>
              </thead>
              <tbody id="unassign-modal_body">
                {orderDetails.map((study, index) => (
                  <tr key={index}>
                    <>
                      <td style={headStyle}>{study.accessionNumber}</td>
                      <td style={headStyle}>{study.modality}</td>
                      <td style={headStyle}>{study.serviceName}</td>
                      <td style={headStyle}>{study.numberOfImages}</td>
                      <td style={headStyle}>{study.reportingStatus}</td>
                    </>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ),
      footer: (
        <ModalFooter
          PrimaryButtonList={[]}
          DefaultButtonList={[
            {
              title: "Close",
              onclick: () => setShowOrderModal(false),
            },
          ]}
        />
      ),
      width: "700px",
    };

    return (<>
    {(rest?.row?.depth == 0 || rest.header) ? (
      <Stack
        style={{
          width: !rest.header ? "40px" : "",
          //  height: !rest.header ? "100px" : "unset",
          justifyContent: "space-evenly",
          alignItems: "center",
          display: "flex",
          flexDirection: `${rest.header ? "row" : "column"}`,
          // marginTop: !rest.header ?(props.roles[0] == USERTYPES.ADMIN ||
          //   props.roles[0] == USERTYPES.FIRMADMIN) ? "10px" : "18px" : "unset",
          //   paddingLeft: rest.header ? "7px" : "unset"
        }}
      >
        {(props.roles[0] == USERTYPES.ADMIN ||
          props.roles[0] == USERTYPES.FIRMADMIN ||
          (props.roles[0] == USERTYPES.SUPERVISOR && allowDeleteStudy) ||
          ((props.roles[0] === USERTYPES.RADIOLOGIST || 
            props.roles[0] === USERTYPES.FIRMTECHNICIAN || 
            props.roles[0] === USERTYPES.FIRMDOCTOR ||
            props.roles[0] === USERTYPES.SUPERVISOR) &&
     REPORTED_TABS_NAME.includes(props.id))) && !(props.id == TAB_NAME.PENDING || props.id == TAB_NAME.APPROVED || props.id == TAB_NAME.REJECTED) && !hideMultiSelectAndUnlock  && (<>
          <Checkbox
            className="study-delete-checkbox"
            ref={ref}
            indeterminate={rest.header && rowSelectedArray.length > 0 && !(Object.keys(rowSelectionState).length == Object.keys(dataQueryState?.data?.rows).length)}
            styles={checkBoxStyle}
            {...rest}
          />
          </>
        )}
        {!rest.header && (
          <>
            {!hideMultiSelectAndUnlock && (<>
            {loadingLockUnlock ? (
              <Spinner size={SpinnerSize.large} styles={smallSpinnerStyle} />
            ) : (
              (isActiveData && !contextSwitchUser && (displayLockIcon || (displayLockIconForQCTab && QC_TABS.includes(props.id)))) ? (
                <CustomToolTipHost content={isBvpPlatform && rest.row.original.assignmentList?.[0]?.providerId === "R" + userId
              ? "Release Study":
                  (!(displayLockIconForQCTab && QC_TABS.includes(props.id))?t("study-list.messages.unassign-study"):getFirmAdminUnLockMessage()) }>
                  <div onClick={() => {
                    setResetRowSelection(true);
                     if (
                       isBvpPlatform &&
                       rest.row.original.assignmentList?.[0]?.providerId ===
                         "R" + userId
                     ) {
                       releaseStudy(rest.row.original);
                     } else if (
                       displayLockIconForQCTab &&
                       QC_TABS.includes(props.id)
                     ) {
                       assignReviewer(
                         rest.row.original,
                         false,
                         props.id === TAB_NAME.QCVERIFY ? false : true
                       );
                     } else {
                       unassignProvider(rest.row.original);
                     }
                    }}>
                    {" "}
                    <Lock lockWarning={false} />{" "}
                  </div>
                </CustomToolTipHost>
              ) : (
                ((props.roles[0] === USERTYPES.ADMIN ||
                  props.roles[0] === USERTYPES.FIRMADMIN ||
                  props.roles[0] === USERTYPES.SUPERVISOR) 
                  && !(displayUnlockIcon || displayUnlockIconForSupervisor)) &&
                <CustomToolTipHost content={t("study-list.messages.cannot-lock-study")}>
                 <div style={{ cursor: "not-allowed",marginTop:REPORTED_TABS_NAME.includes(props.id) ? "10px":"unset" }}>
                    {" "}
                    <Lock lockWarning={true} />{" "}
                  </div>
                </CustomToolTipHost>
              )
            )}
            { (isActiveData && (displayUnlockIcon || displayUnlockIconForSupervisor)) ? (
              <CustomToolTipHost content={displayUnlockIcon?t("study-list.messages.lock-start-reporting"):getSupervisorlockMessage()}>
                <div onClick={() => {
                  if(displayUnlockIconForSupervisor){
                    assignReviewer(rest.row.original,true,props.id === TAB_NAME.QCVERIFY?false:true);
                  }else if(props.roles[0] === USERTYPES.TYPIST){
                    assignTypist(rest.row.original);
                  }
                  
                  else{
                    assignProvider(rest.row.original);
                  }
                 }}>
                  {" "}
                  <LockOpen lockAllowed={true} />{" "}
                </div>
              </CustomToolTipHost>
            )
              :  ((roles[0] == USERTYPES.RADIOLOGIST && props.id !== TAB_NAME.QCFIX)||roles[0] == USERTYPES.TYPIST) && (!isBvpPlatform || (rest.row.original.assignmentList[0].providerId!=="R" + userId) || rest.row.original.reportDoneStatus>=2)  && (
                <CustomToolTipHost content={t("study-list.messages.cannot-lock-study")}>
                  <div style={{ cursor: "not-allowed" }}>
                    {" "}
                    <Lock lockWarning={true} />{" "}
                  </div>
                </CustomToolTipHost>
              )
            }
            </>)}
            {roles[0] !== USERTYPES.TYPIST && rest.row.original.priorsCount > 0 && rest.row.original.showPriors && props.id !== TAB_NAME.CLOSED &&
              getEnv("REACT_APP_SHOW_PRIORS") == "true" && (
                <div  {...{ onClick: () => {
                  console.log("--- Prior For Now Commented ---")
                  fetchPriorsData(rest.row)
                }
                 }}>
                  {!priorsLoading ? 
                  <CustomToolTipHost content={t("label.prior")}>
                  <Accordian rotated={rest?.row?.getIsExpanded()}/> 
                  </CustomToolTipHost>
                  : <Spinner size={SpinnerSize.large} styles={smallSpinnerStyle} />}
                </div>
              )}

            {roles[0] === USERTYPES.RADIOLOGIST && isVdcPlatform && rest.row.original.orderStudyInfoDtos && rest.row.original.orderStudyInfoDtos.length > 0 && <>
                <span
                              className="study-list-assignment-details-text"
                              
                              onClick={() => handleOpenOrderModal(rest.row.original)}>
                              <RowBadgeStatic
                                clickable={true}
                                name={`+${rest.row.original.orderStudyInfoDtos.length}`}
                                tooltipText={<div style={{ padding: 4 }}>
                                  {rest.row.original.orderStudyInfoDtos.map((info, index) => (
                                    <div key={index} style={{ marginBottom: 4 }}>
                                      {info.accessionNumber}
                                      {" : "}
                                      {info.serviceName}
                                    </div>
                                  ))}
                                </div>}
                              />
                            </span>
                
          
            </>}

            {rest?.row?.getIsExpanded() && <div className="study-list-prior-line-container"
            style={{height:(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN) ? '0px': (window.innerWidth <= 1200 ? '55px' : '35px'),position:'absolute',bottom:'0',left:'0'}}>
        <div className="study-list-prior-line"></div>

      </div>}
          </>
        )}
      </Stack>)
      : !rest.header ? <div className={`${rest?.row?.getParentRow()?.subRows.length - 1 === rest?.row?.index ? "study-list-prior-last-line-container":"study-list-prior-line-container"}`}>
        <div 
        className={`${rest?.row?.getParentRow()?.subRows.length - 1 === rest?.row?.index ? "study-list-prior-last-line":"study-list-prior-line"}`}
        ></div>

      </div>:<></>   
  }

  {showOrderModal && (
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails}
            showModal={true}
          />
        )}
  </>);
}

  

export default IndeterminateCheckbox;